import React, {useMemo} from "react"
import { Layout } from "./Layout";
import {useSiren} from "./SirenContext";
import {ContactGroupCreate} from "./subpages/ContactGroupCreate";
import { AudioUpload } from "./subpages/AudioUpload";
import {AudioList} from "./subpages/AudioList";
import {AudioTextToSpeech} from "./subpages/AudioTextToSpeech";

export function Audio() {
    const {subMenuCurrent} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "files": return <AudioList/>
            case "upload": return <AudioUpload/>
            case "text-to-speech": return <AudioTextToSpeech/>
        }

        return null
    },[subMenuCurrent])


    return (
        <Layout menuCurrent={"audio"} >
            {page}
        </Layout>
    )



}